/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillaryManagerFormData
 */
export interface AncillaryManagerFormData {
    /**
     * 
     * @type {string}
     * @memberof AncillaryManagerFormData
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AncillaryManagerFormData
     */
    apiName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AncillaryManagerFormData
     */
    ancillaryName?: string | null;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof AncillaryManagerFormData
     */
    ancillaryCategory?: Int32IdAndLabel;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof AncillaryManagerFormData
     */
    weight?: Int32IdAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof AncillaryManagerFormData
     */
    allowEdit?: boolean;
}

export function AncillaryManagerFormDataFromJSON(json: any): AncillaryManagerFormData {
    return AncillaryManagerFormDataFromJSONTyped(json, false);
}

export function AncillaryManagerFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillaryManagerFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'apiName': !exists(json, 'apiName') ? undefined : json['apiName'],
        'ancillaryName': !exists(json, 'ancillaryName') ? undefined : json['ancillaryName'],
        'ancillaryCategory': !exists(json, 'ancillaryCategory') ? undefined : Int32IdAndLabelFromJSON(json['ancillaryCategory']),
        'weight': !exists(json, 'weight') ? undefined : Int32IdAndLabelFromJSON(json['weight']),
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function AncillaryManagerFormDataToJSON(value?: AncillaryManagerFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'apiName': value.apiName,
        'ancillaryName': value.ancillaryName,
        'ancillaryCategory': Int32IdAndLabelToJSON(value.ancillaryCategory),
        'weight': Int32IdAndLabelToJSON(value.weight),
        'allowEdit': value.allowEdit,
    };
}


